import React, { useState } from "react";
import Modal from "../../../../components/__common/Modal/Modal";
import Accordion from "../../../../components/__common/Accordion/Accordion";
import { Col, Container, Row } from "../../../../components/Grid/Grid";
import { t } from "i18next";
import {
  CBType,
  Checkbox,
} from "../../../../components/__common/_controls/Checkbox/Checkbox";
import "./LocalPrivacySiteModal.scss";
import triggerGAEvent from "../../../../utils/UtilsTriggerGAEvent";
import {
  EVENT_CATEGORY_LANDING_PAGE,
  EVENT_LANDING_PAGE_LOCAL_PRIVACY,
} from "../../../../constants/analytics";
import { UtilsLocale } from "../../../../utils/UtilsLocale";
import { HubRegions } from "../../../../data/landing-page";
import { HubCountry } from "../../../../types/landing-page";
import { useLayout } from "../../../../hooks/layout-hooks";

interface Props {
  show: boolean;
  onClickClose: () => void;
}

const LocalPrivacySiteModal: React.FC<Props> = ({ show, onClickClose }) => {
  const [selectedRegion, setSelectedRegion] = useState<any>();
  const { setSelectedCountry } = useLayout();

  const handleGAEvent = (countryCode: string) => {
    const iso2Code = UtilsLocale.convertISO3toISO2(countryCode);
    triggerGAEvent(
      EVENT_CATEGORY_LANDING_PAGE,
      `${EVENT_LANDING_PAGE_LOCAL_PRIVACY}-${iso2Code}`
    );
  };

  const handlePrivacySite = (country: HubCountry) => {
    setSelectedCountry(country);
  };

  return (
    <Modal className="local-privacy-modal" show={show}>
      <Modal.Header onHide={onClickClose}>
        <Modal.Title>{t("PRIVACY_GRRS_SELECT_COUNTRY")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Accordion>
          {HubRegions.map((region, index) => (
            <Accordion.Item
              id={index === HubRegions.length - 1 ? "last-region" : region.name}
              title={region.name}
              key={region.name}
              activeItem={selectedRegion && selectedRegion.name}
              onClick={(isActive) => {
                if (isActive) {
                  setSelectedRegion(region);
                } else {
                  setSelectedRegion(undefined);
                }
              }}
            >
              <Container>
                <Row>
                  {region.countries.map((country) => {
                    const lastRegion = HubRegions[HubRegions.length - 1];
                    const lastCountry =
                      lastRegion.countries[lastRegion.countries.length - 1]
                        .name;

                    return (
                      <Col md={6} sm={12} key={country.code}>
                        <Checkbox
                          id={
                            country.name === lastCountry
                              ? "last-language"
                              : country.code
                          }
                          key={country.code}
                          title={country.displayName}
                          name="checkbox-withoutSelectBg"
                          type={CBType.withoutSelectBg}
                          //checked={isChecked(country.code, language.code)}
                          // onClick={() => {
                          //   handleGAEvent(country.code);
                          //   handlePrivacySite(country);
                          //   onClickClose();
                          // }}
                          onChange={() => {
                            handleGAEvent(country.code);
                            handlePrivacySite(country);
                            onClickClose();
                          }}
                        />
                      </Col>
                    );
                  })}
                </Row>
              </Container>
            </Accordion.Item>
          ))}
        </Accordion>
      </Modal.Body>
    </Modal>
  );
};

export default LocalPrivacySiteModal;
